import { colors } from './fontStyles';

export const primaryBulletStyle = (theme) => ({
  listStyleType: 'disc',
  display: 'list-item',
  color: theme.custom.pages.howTo.howToUnderstandPFASStyles.primaryBulletStyle.color,
  marginLeft: '0.3em',
  padding: '0px',
});

export const secondaryBulletStyle = (theme) => ({
  listStyleType: 'disc',
  display: 'list-item',
  color: theme.custom.pages.howTo.howToUnderstandPFASStyles.secondaryBulletStyle.color,
  marginLeft: '0.3em',
  padding: '0px',
});

export const primaryListItemStyle = (theme) => ({
  color: theme.custom.pages.howTo.howToUnderstandPFASStyles.primaryListItemStyle.color,
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '0.25px',
});

export const secondaryListItemStyle = (theme) => ({
  color: theme.custom.pages.howTo.howToUnderstandPFASStyles.secondaryListItemStyle.color,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.25px',
});

export const primaryBlueLinkStyle = {
  color: colors.primaryBlue,
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '16px',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'auto',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',
};
